import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import { HandoverConfigSchema } from './handover.schema';

const {
  APPLICATION: { APPLICATION_LIST_SETTINGS, APPLICATION_UPDATE_SETTINGS },
} = PERMISSIONS;

export const handoverContract = createRESTContract({
  updateHandoverConfig: {
    method: 'POST',
    path: '/handover',
    permissions: [APPLICATION_UPDATE_SETTINGS],
    response: z.void(),
    body: HandoverConfigSchema,
  },
  getHandoverConfig: {
    method: 'GET',
    path: '/handover',
    permissions: [APPLICATION_LIST_SETTINGS],
    response: HandoverConfigSchema,
  },
});
